import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  Stack,
  Text,
  Select
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { getListSelectCiudad } from '../../features/ciudadSlice';
import { getConfiguraciones, updateConfiguraciones } from '../../features/configuracionesSlice';
import { ToastChakra } from '../../helpers/toast';
import { Loading } from '../../helpers/Loading';
import { LogoUploader } from './LogoUploader'


const Configuraciones = () => {
  const dispatch = useDispatch();

  const initialValues = {
    nombres: '',
    direccion: '',
    dni: '',
    ciudadId: '',
    email: '',
    celular: '',
    cuentaBancaria: '',
    logo: null // nuevo campo
  };

  const [indice, setIndice] = useState(initialValues);
  const [cargando, setCargando] = useState(false);

  const { ciudades } = useSelector((state) => state.ciudades);
  const { configuracionesList ,isError,message,isLoading} = useSelector((state) => state.configuraciones);

  useEffect(() => {
    dispatch(getListSelectCiudad());
    dispatch(getConfiguraciones());
  }, [dispatch]);

  useEffect(() => {
    if (configuracionesList) {
      setIndice({
        nombres: configuracionesList.nombre || '',
        direccion: configuracionesList.direccion || '',
        dni: configuracionesList.dni || '',
        ciudadId: configuracionesList.ciudadId || '',
        email: configuracionesList.email || '',
        celular: configuracionesList.telefono || '',
        cuentaBancaria: configuracionesList.cuenta || ''
      });
    }
  }, [configuracionesList]);

   if (isError) {
        ToastChakra('Error', message, 'error', 3000);
        console.log(message);
   }
  const handleSave = (e) => {
    e.preventDefault();
    setCargando(true);
    // Aquí va la lógica para guardar los datos...
    // Construye el objeto de datos para enviar al backend
    const formData = new FormData();

    formData.append('nombres', indice.nombres);
    formData.append('direccion', indice.direccion);
    formData.append('dni', indice.dni);
    formData.append('ciudadId', indice.ciudadId);
    formData.append('email', indice.email);
    formData.append('celular', indice.celular);
    formData.append('cuenta', indice.cuentaBancaria);
  
    if (indice.logo) {
      formData.append('logo', indice.logo);
    }

    dispatch(updateConfiguraciones(formData))
    .then(() => {
    })
    .catch((error) => {
      console.error("Error al actualizar la configuración:", error);
    })
    .finally(() => {
      setCargando(false);
    });
   
  };

  if(isLoading) {
    return <Loading />
  }

  return (
    <>
      <Stack spacing={4} direction="row" justifyContent="space-between" py={4}>
        <HStack spacing={4} direction="row">
          <Text fontSize="lg" fontWeight={'bold'}>
            Configuraciones de Factura
          </Text>
        </HStack>
      </Stack>

      <form onSubmit={handleSave}>
        <Box
          borderRadius="2xl"
          boxShadow="base"
          overflow="hidden"
          bg="white"
          _dark={{ bg: 'primary.1000' }}
          mt={4}
          p={6}
        >
          <Stack spacing={6} direction="column" justifyContent="space-between" p={2}>
            <Stack spacing={2} direction={{ base: 'column', lg: 'row' }} justifyContent="space-between">
              <FormControl isRequired>
                <FormLabel fontWeight={'semibold'}>NOMBRES</FormLabel>
                <Input
                  value={indice.nombres}
                  placeholder="Escribe los nombres"
                  type="text"
                  onChange={(e) => setIndice({ ...indice, nombres: e.target.value })}
               
                />
              </FormControl>
              <FormControl isRequired>
                <FormLabel fontWeight={'semibold'}>DIRECCION</FormLabel>
                <Input
                  value={indice.direccion}
                  placeholder="Escribe la dirección"
                  type="text"
                  onChange={(e) => setIndice({ ...indice, direccion: e.target.value })}
                
                />
              </FormControl>
            </Stack>

            <Stack spacing={2} direction={{ base: 'column', lg: 'row' }} justifyContent="space-between">
              <FormControl isRequired>
                <FormLabel fontWeight={'semibold'}>DNI</FormLabel>
                <Input
                  value={indice.dni}
                  placeholder="Ejemplo: 71499918"
                  type="text"
                  onChange={(e) => setIndice({ ...indice, dni: e.target.value })}
                />
              </FormControl>
              <FormControl>
                <FormLabel fontWeight={'semibold'}>CORREO</FormLabel>
                <Input
                  value={indice.email}
                  placeholder="Ejemplo: usuario@gmail.com"
                  type="email"
                  onChange={(e) => setIndice({ ...indice, email: e.target.value })}
                />
              </FormControl>
            </Stack>

            <Stack spacing={2} direction={{ base: 'column', lg: 'row' }} justifyContent="space-between">
              <FormControl fontWeight={'semibold'}>
                <FormLabel>CELULAR</FormLabel>
                <InputGroup>
                  <Input
                    value={indice.celular}
                    placeholder="Escribe el celular"
                    type="tel"
                    onChange={(e) => setIndice({ ...indice, celular: e.target.value })}
                  />
                </InputGroup>
              </FormControl>

              <FormControl isRequired>
                <FormLabel fontWeight={'semibold'}>CIUDAD</FormLabel>
                <Select
                  placeholder="Seleccione una ciudad"
                  value={indice.ciudadId}
                  onChange={(e) => setIndice({ ...indice, ciudadId: e.target.value })}
                >
                  {ciudades.map((ciudad) => (
                    <option key={ciudad.id} value={ciudad.id}>
                      {ciudad.descripcion}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Stack>

            <Stack spacing={2} direction={{ base: 'column', lg: 'row' }} justifyContent="space-between">
              <FormControl fontWeight={'semibold'}>
                <FormLabel>CUENTA BANCARIA</FormLabel>
                <InputGroup>
                  <Input
                    value={indice.cuentaBancaria}
                    placeholder="Escribe la cuenta bancaria"
                    type="tel"
                    onChange={(e) => setIndice({ ...indice, cuentaBancaria: e.target.value })}
                  />
                </InputGroup>
              </FormControl>

              <FormControl>
               <LogoUploader indice={indice} setIndice={setIndice} />
              </FormControl>

            </Stack>
            
          </Stack>

          <Stack spacing={4} direction="row" justifyContent="right">
            <Button
              colorScheme="purple"
              _dark={{ bg: 'purple.500', color: 'white', _hover: { bg: 'purple.600' } }}
              loadingText="Guardando..."
              spinnerPlacement="start"
              size="lg"
              type="submit"
              isLoading={cargando}
              disabled={indice.nombres === '' || indice.direccion === '' || indice.dni === ''}
              borderRadius="xl"
            >
              Guardar
            </Button>
          </Stack>
        </Box>
      </form>
    </>
  );
};

export default Configuraciones;
